<template>
  <!-- WELCOME -->
  <section class="py-14">
    <!-- Content -->
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-8 text-center">
          <!-- Heading -->
          <h2>Page not found</h2>

          <!-- Text -->
          <p class="fs-lg text-muted mb-7 mb-md-9">
            The link that brought you here is unfortunately dead. Try heading to
            our home page and go from there.
          </p>

          <router-link to="/" class="btn btn-primary me-1 lift">
            Go home <i class="fe fe-arrow-right ms-3"></i>
          </router-link>
        </div>
      </div>
      <!-- / .row -->
    </div>
    <!-- / .container -->
  </section>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped></style>
